<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="flex justify-content-center" *ngIf="loading">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <form #f="ngForm" name="form" *ngIf="franquia && !loading">
                <div class="formgroup">
                    <div class="flex justify-content-between align-items-center">
                        <h4 class="m-0">{{ franquia.nomeFantasia }}</h4>
                        <button
                            type="button"
                            pButton
                            icon="pi pi-pencil"
                            label="Editar"
                            class="p-button-outlined"
                            (click)="editarDados()"
                        ></button>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div class="col-12 md:col-12">
                            <h5>Dados Principais</h5>
                        </div>

                        <!-- <div class="form-group field col-12 md:col-12">
                            <div class="profile-picture-container">
                                <img
                                    [src]="croppedImage"
                                    alt="Profile Picture"
                                    class="profile-picture-circular"
                                />
                            </div>
                            <label for="profile-picture" class="upload-icon">
                                <input
                                    type="file"
                                    id="profile-picture"
                                    (change)="fileChangeEvent($event)"
                                    accept="image/*"
                                    hidden
                                />
                                <i class="pi pi-upload"></i>
                            </label>
                        </div> -->

                        <div class="form-group field col-12 md:col-6">
                            <label>Nome Franquia</label>
                            <label class="form-control">{{ franquia.nomeFantasia }}</label>
                        </div>
                        <div class="form-group field col-12 md:col-6">
                            <label>Razão Social</label>
                            <label class="form-control">{{ franquia.razaoSocial }}</label>
                        </div>
                        <div class="form-group field col-12 md:col-3">
                            <label>CNPJ</label>
                            <label class="form-control">{{ franquia.cnpj | cnpjFormat }}</label>
                        </div>

                        <div class="form-group field col-12 md:col-4">
                            <label htmlFor="email">E-mail</label>
                            <input
                                pInputText
                                type="email"
                                id="campoEmail"
                                placeholder="email@mail.com"
                                name="email"
                                ngModel
                                email="true"
                                #email="ngModel"
                                [(ngModel)]="franquia.email"
                                [readonly]="!editar"
                            />
                            <div *ngIf="email.hasError('email')" class="alerta">
                                <small>Digite um e-mail válido</small>
                            </div>
                        </div>

                        <div class="col-12 md:col-12">
                            <h5>Endereço</h5>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="cep">CEP</label>
                            <p-inputMask
                                mask="99999-999"
                                [unmask]="true"
                                placeholder="00000-000"
                                name="cep"
                                ngModel
                                #cep="ngModel"
                                [(ngModel)]="franquia.cep"
                                [readonly]="!editar"
                            ></p-inputMask>
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="logradouro">Logradouro</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                pInputText
                                type="text"
                                name="logradouro"
                                ngModel
                                #logradouro="ngModel"
                                [(ngModel)]="franquia.logradouro"
                                [readonly]="!editar"
                            />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="bairro">Bairro</label>
                            <input
                                pInputText
                                type="text"
                                name="bairro"
                                ngModel
                                oninput="this.value = this.value.toUpperCase();"
                                [(ngModel)]="franquia.bairro"
                                #bairro="ngModel"
                                [readonly]="!editar"
                            />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="numero">Número</label>
                            <input
                                pInputText
                                type="text"
                                name="numero"
                                ngModel
                                #numero="ngModel"
                                [(ngModel)]="franquia.numero"
                                [readonly]="!editar"
                            />
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="complemento">Complemento</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                pInputText
                                type="text"
                                name="complemento"
                                ngModel
                                #complemento="ngModel"
                                [(ngModel)]="franquia.complemento"
                                [readonly]="!editar"
                            />
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="uf">Estado</label>
                            <p-dropdown
                                [options]="listaUfs"
                                optionLabel="label"
                                optionValue="label"
                                [editable]="true"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                (onChange)="carregarMunicipios(true)"
                                placeholder="UF"
                                name="uf"
                                ngModel
                                #uf="ngModel"
                                [(ngModel)]="franquia.uf"
                                [readonly]="!editar"
                                [required]="true"
                            ></p-dropdown>
                        </div>

                        <div class="field col-12 md:col-7">
                            <label htmlFor="cidade">Cidade</label>
                            <p-dropdown
                                [options]="listaMunicipios"
                                optionLabel="label"
                                optionValue="label"
                                [editable]="true"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione a Cidade"
                                name="cidade"
                                ngModel
                                #cidade="ngModel"
                                [(ngModel)]="franquia.cidade"
                                [readonly]="!editar"
                                [required]="true"
                            ></p-dropdown>
                        </div>

                        <div class="col-12 md:col-12">
                            <h5>Contatos</h5>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="telefone">Telefone</label>
                            <p-inputMask
                                mask="(99)9999-9999"
                                [unmask]="true"
                                type="text"
                                placeholder="(00)0000-0000"
                                [(ngModel)]="franquia.telefone"
                                name="telefone"
                                ngModel
                                #telefone="ngModel"
                                [readonly]="!editar"
                            ></p-inputMask>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="whatsapp">Whatsapp</label>
                            <p-inputMask
                                mask="(99)99999-9999"
                                [unmask]="true"
                                type="text"
                                placeholder="(00)00000-0000"
                                [(ngModel)]="franquia.whatsapp"
                                name="whatsapp"
                                ngModel
                                #whatsapp="ngModel"
                                [readonly]="!editar"
                            ></p-inputMask>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-2">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                (click)="atualizar()"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!editar || f.invalid"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="submit"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Atualizando..."
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/rfarias/dashboard"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
